import { Injectable } from '@angular/core';
import {Condition, CardType, Language} from '../core/entities/entities';
import {FakeService} from '../core/services/FakeService';
import {HttpService} from '../core/services/http.service';
import {HttpServiceBase} from '../core/services/HttpServiceBase';

@Injectable()
export class CardConditionService extends HttpServiceBase<Condition>  {

  getCleanInstance(): Condition {
    return new Condition();
  }

  public hasSingleGet(){
    return false;
  }

  public refreshOnRouteChange(){
    return false;
  }

  getUrl(): string {
    return 'condition';
  }

  public fromJson(json): Condition {
    const me = this;
    const item: Condition = Object.assign(this.getCleanInstance(), json);

    if(json.condition){
      item.description = json.condition || json.description ;
    }
    item.shortDescr = json.code;
    item.code = '' + item.id;

    return item;
  }

  constructor(http: HttpService) {
    super(http);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/card-condition.service.ts